import { React, useEffect, useState } from "react";
import { make_request_bids } from '../services/api';
import { errorMsg } from "../../../helper/helpers";
import ScmModuleStyle from "../styles/scm.module.css";
import Button from "../../common/Button";
import warning from "../assets/warning.png";

const RequestBid = ({ simObj, setSimObj, formatNum, setError, toggleSimulation, setToggleSimulation, isRequestLoading, setIsShowRequestBid, getMonth}) => {
  const [suppliers,setSupplicers] = useState([]);
  const [isToggledRequestBidPopup, setIsToggledRequestBidPopup] = useState(false);
  const noOfRatings = [1, 2, 3, 4, 5];
  const starRating = 2;
  const onMouseOverHandler = (event) => {
    let left = event.currentTarget.offsetLeft + 23;
    let top = (event.currentTarget.offsetTop - (window.$(event.currentTarget.nextSibling).outerHeight() / 2) + 3);
    window.$(event.currentTarget.nextSibling).removeAttr("style")
    window.$(event.currentTarget.nextSibling).removeClass("bottom");
    window.$(event.currentTarget.nextSibling).addClass("top left");
    window.$(event.currentTarget.nextSibling).css("left", left);
    window.$(event.currentTarget.nextSibling).css("top", top);
  }
  const RequestedBids = () =>{ 
    window.$(".request-bid-checkbox").prop("checked",true);
    let copySimObj = {...simObj};
    delete copySimObj.artifacts;
    delete copySimObj.graphdata;
    delete copySimObj.supplierInformations;
    delete copySimObj.supplierDetails;
    make_request_bids(copySimObj?.sessionid,copySimObj).then(function (response) {
      if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
        setError(response?.data)
    }
    else{
          setIsShowRequestBid(true);
          setSimObj(response.data);
          setToggleSimulation(true)
        setError(null);
    }
      }).catch((error) => {
        // setError(errorMsg);
        setError({"id":"00000","msg":errorMsg})
      })
      clearBid();
  }
  const clearBid = () =>{
    window.$(".request-bid-checkbox").prop("checked",false);
    setSupplicers([]);
  }
  /*Request bid tooltip*/ 
  const handleToggleRequestBidPopup = (event) => {
      if(event === undefined){
      return;
      }
      setIsToggledRequestBidPopup(!isToggledRequestBidPopup);
  };
  
  const handleKeyDownRequestBidPopup = (event) => {
      // Toggle the button when Enter or Space is pressed
      if (event.key === 'Enter' || event.key === ' ') {
      handleToggleRequestBidPopup();
      }
  };
  window.$(document).on("click", function(e){
      if(!window.$(e.target).closest('#requestBidPopup').length > 0){
      setIsToggledRequestBidPopup(false);
      }
  });
  useEffect(()=>{
    let newActions = {...simObj?.actions,['scmDecision']:{...simObj?.actions?.scmDecision,['requestedBids']: suppliers}}
    setSimObj((prevSimObj) => ({
      ...prevSimObj,
      ['actions']: newActions
    }))
    document.getElementById("playSumButton")?.toggleAttribute("disabled", suppliers.length);
  },[suppliers])
  useEffect(() => {
    window.$('.requestbid .supplier_details:not([initialize="true"])').attr("initialize",true).off('click').popup({
      inline: true,
      hoverable: false,
      on: 'click',
      boundary: 'table',
    });
    clearBid();
  }, [simObj?.supplierDetails])
  return (
    <div className={`${ScmModuleStyle["current-decision"]}`}>
      <div className={`${ScmModuleStyle["forecast-decision"]}`}>
      <p>Please Select any Supplier for requesting bid</p>
        <div className={`${ScmModuleStyle["decisions-table"]}`}>          
          <div className={`${ScmModuleStyle["decision-table-parent"]}`}>
            <table className="ui celled table unstackable requestbid">
              <thead>
                <tr>
                  <th>Supplier Name</th>
                  <th className={`${ScmModuleStyle["tooltip-rqst-bid"]}`}>
                    <span style={{"float":"left"}}>
                      Request Bid
                      {/* <a 
                        id="requestBidPopup"
                        className={}
                        href="javascript:void(0)"
                        // data-tooltip="After every order, you'll need to request a new bid!"
                        // data-position="bottom center"
                        onClick={(e)=>e.preventDefault()}
                      >
                        <img src={warning} alt="" />
                      </a> */}
                      <a id="requestBidPopup" className={`${ScmModuleStyle["requestAnchor"]}`} href="javascript:void(0)" role="button" tabIndex={0} aria-label="Info about Request bid" onClick={handleToggleRequestBidPopup} 
                        onKeyDown={handleKeyDownRequestBidPopup}
                        onMouseEnter={()=> {
                        if(window.innerWidth > 991) {
                            setIsToggledRequestBidPopup(true);
                        }
                        }}
                        onMouseLeave={()=> {
                        if(window.innerWidth > 991) {
                            setIsToggledRequestBidPopup(false);
                        }
                        }}
                        onBlur={()=> setIsToggledRequestBidPopup(false)}><img src={warning} alt="" /></a>
                      <div className={`ui fluid popup bottom center transition ${ScmModuleStyle.ui} ${ScmModuleStyle.fluid} ${ScmModuleStyle.popup} ${ScmModuleStyle["request-bid-popup"]}`} style={{ display: isToggledRequestBidPopup == true ? "block" : "none" }}>
                          <p role="alert" aria-live="assertive">After every order, you'll need to request a new bid!</p>
                      </div>
                    </span>
                  </th>
                  <th>Bid Cost</th>
                </tr>
              </thead>
              <tbody>
                <tr className={`${ScmModuleStyle["internal-headers"]}`}>
                  <td colSpan={3}>SKU1</td>
                </tr>
                {
                  simObj?.supplierDetails != null && Object.entries(simObj?.supplierDetails)?.map(([supplier_id, supplier]) => (
                    supplier?.supplierComp1Available ? (<tr key={supplier_id}>
                      <td>
                        <span>{supplier?.supplierName}</span>
                        <a href="javascript:void(0)" role="button" onClick={onMouseOverHandler} className={`ui supplier_details ${ScmModuleStyle.ui} ${ScmModuleStyle.supplier_details}`}>
                          <img src={warning} alt="supplier info popup" />
                        </a>
                        <div className={`ui fluid popup top left transition hidden ${ScmModuleStyle.ui} ${ScmModuleStyle.fluid} ${ScmModuleStyle.popup}`} role="alert" aria-live="assertive">
                          <div className="ui column divided center aligned grid">
                            <div className={`column ${ScmModuleStyle["imgtxt"]}`}>
                              <img src={`${require(`../assets/suppliers/${supplier_id}.png`)}`} alt={supplier_id} style={{ width: '60px' }} />
                              <p style={{ marginTop : '0px' }}>{supplier?.supplierPromotion}</p></div>
                          </div>
                          <div className="ui column divided center aligned grid">
                            <div className={`column ${ScmModuleStyle["rating"]}`}>
                              <div className={`${ScmModuleStyle["quality-star-rating"]}`}>
                                <span>Quality Rating</span>
                              </div>
                              <ul className={`${ScmModuleStyle["rating-list"]}`}>
                                {noOfRatings.map((number, index) =>
                                  number <= supplier?.starRating ? (
                                    <li key={number}>
                                      <span className={`fa fa-star checked ${ScmModuleStyle["fa"]} ${ScmModuleStyle["fa-star"]}`} />
                                    </li>
                                  ) : Number(supplier?.starRating) === supplier?.starRating &&
                                  supplier?.starRating % 1 !== 0 &&
                                    number <= Math.round(supplier?.starRating) ? (
                                    <li key={number}>
                                      <span className={`fa fa-star-half-o ${ScmModuleStyle["fa"]} ${ScmModuleStyle["fa-star-half-o"]}`} />
                                    </li>
                                  ) : (
                                    <li key={number}>
                                      <span className={`fa fa-star-o ${ScmModuleStyle["fa"]} ${ScmModuleStyle["fa-star-o"]}`} />
                                    </li>
                                  )
                                )}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </td>

                      <td>
                        <div className={`${ScmModuleStyle["inputBox"]}`}>
                          <input className="request-bid-checkbox" disabled={simObj?.status=="COMPLETED" || toggleSimulation || !simObj?.supplierInformations.filter((supplier)=>supplier.supplierId == supplier_id)[0].isEnabled} value={supplier_id} type="checkbox" onChange={(event) => { (event.target.checked == true) ?  setSupplicers(prevSupplier => ([...prevSupplier,event.target.value])) : setSupplicers(prevSupplier => ([...prevSupplier.filter((item)=> item != event.target.value)]))}} />
                        </div>
                      </td>
                      <td>${supplier?.supplierBidCost}</td>
                    </tr>) : ''
                  ))
                }


                <tr className={`${ScmModuleStyle["internal-headers"]}`}>
                  <td colSpan={3}>SKU2</td>
                </tr>
                {
                  simObj?.supplierDetails != null && Object.entries(simObj?.supplierDetails)?.map(([supplier_id, supplier]) => (
                    supplier?.supplierComp2Available ? (<tr key={supplier_id}>
                      <td>
                        <span>{supplier?.supplierName}</span>
                        <a href="javascript:void(0)" role="button" onClick={onMouseOverHandler} className={`ui supplier_details ${ScmModuleStyle.ui} ${ScmModuleStyle.supplier_details}`}>
                          <img src={warning} alt="supplier info popup" />
                        </a>
                        <div className={`ui fluid popup top left transition hidden ${ScmModuleStyle.ui} ${ScmModuleStyle.fluid} ${ScmModuleStyle.popup}`} role="alert" aria-live="assertive">
                          <div className="ui column divided center aligned grid">
                            <div className={`column ${ScmModuleStyle["imgtxt"]}`}>
                              <img src={`${require(`../assets/suppliers/${supplier_id}.png`)}`} alt={supplier_id} style={{ width: '60px' }} />
                              <p style={{ marginTop : '0px' }}>{supplier?.supplierPromotion}</p></div>
                          </div>
                          <div className="ui column divided center aligned grid">
                            <div className={`column ${ScmModuleStyle["rating"]}`}>
                              <div className={`${ScmModuleStyle["quality-star-rating"]}`}>
                                <span>Quality Rating</span>
                              </div>
                              <ul className={`${ScmModuleStyle["rating-list"]}`}>
                                {noOfRatings.map((number, index) =>
                                  number <= supplier?.starRating ? (
                                    <li key={number}>
                                      <span className={`fa fa-star checked ${ScmModuleStyle["fa"]} ${ScmModuleStyle["fa-star"]}`} />
                                    </li>
                                  ) : Number(supplier?.starRating) === supplier?.starRating &&
                                  supplier?.starRating % 1 !== 0 &&
                                    number <= Math.round(supplier?.starRating) ? (
                                    <li key={number}>
                                      <span className={`fa fa-star-half-o ${ScmModuleStyle["fa"]} ${ScmModuleStyle["fa-star-half-o"]}`} />
                                    </li>
                                  ) : (
                                    <li key={number}>
                                      <span className={`fa fa-star-o ${ScmModuleStyle["fa"]} ${ScmModuleStyle["fa-star-o"]}`} />
                                    </li>
                                  )
                                )}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </td>

                      <td>
                        <div className={`${ScmModuleStyle["inputBox"]}`}>
                          <input className="request-bid-checkbox" disabled={simObj?.status=="COMPLETED" || toggleSimulation || !simObj?.supplierInformations.filter((supplier)=>supplier.supplierId == supplier_id)[0].isEnabled} value={supplier_id} type="checkbox" onChange={(event) => {(event.target.checked == true) ?  setSupplicers(prevSupplier => ([...prevSupplier,event.target.value])) : setSupplicers(prevSupplier => ([...prevSupplier.filter((item)=> item != event.target.value)]))}} />
                        </div>
                      </td>
                      <td>${supplier?.supplierBidCost}</td>
                    </tr>) : ''
                  ))
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className={`${ScmModuleStyle["avail-invest-list-controls"]}`}>
        <div>
          {/* <Button btnName="Skip" btnWidth={70} customBtnStyle={{ background: "transparent", color: "#B2347B", border: "1px solid #B2347B" }} /> */}
          <Button btnName="Clear" disabled={!suppliers.length} clickEventHandler={clearBid} btnClass={`${ScmModuleStyle["clearBidsBtn"]}`} btnWidth={80} customBtnStyle={{backgroundColor: "transparent",color: "rgb(178, 52, 123)",border: "1px solid rgb(178, 52, 123)"}}/>
          <Button btnName="Request Bids" disabled={!suppliers.length} clickEventHandler={RequestedBids} id="requestBtn" btnWidth={140} />
        </div>
      </div>
    </div>
  );
};

export default RequestBid;
